import PropTypes from 'prop-types';

import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.custom.shadows.paper,
  border: 'none',
  borderRadius: 4,
}));

const Portlet = ({ children, sx, ...rest }) => (
  <StyledPaper elevation={0} variant="outlined" square={false} {...rest} sx={sx}>
    {children}
  </StyledPaper>
);

Portlet.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

export default Portlet;
